function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 .96)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 61,
  height: 61,
  y: 0.5,
  fill: "#000",
  rx: 30.5
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "#FFF",
  strokeWidth: 4,
  transform: "translate(15.5 15.985)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0.858,
  x2: 29.142,
  y1: 0.873,
  y2: 29.157
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.858,
  x2: 29.142,
  y1: 29.157,
  y2: 0.873
})));

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 63,
    viewBox: "0 0 61 63"
  }, props), _ref);
}

export default __webpack_public_path__ + "media/schedule/images/close-b40fcbf97c45e0d2611059bdb2ed022b.svg";
export { SvgClose as ReactComponent };